import firebase from 'firebase/app';
import 'firebase/firestore';
import 'firebase/auth';



export const auth = {

    data() {
        return {
            user_home_client: false,
            user_role: false,
            authListener: [],
            authLoading: false,
            wrong_password: false,
            user: false
        }
    },
    methods: {
        clearAuthListener() {
            this.authListener = []
            for (let l of this.authListener) {
                l()
            }
        },
        forgot_func(email) {
            firebase.auth().sendPasswordResetEmail(email).then(() => {
                console.log("password reset sent")
            }).catch((error) => {
                console.log("error: ", error)
            });
        },
        getUser() {
            return { role: localStorage.getItem("user_role"), uid: localStorage.getItem("uid"), client: localStorage.getItem("user_client") }
        },
        startSpecialCaseUserListener(uid) {
            let vm = this;
            let l = firebase.firestore().collection('users').doc(uid).onSnapshot(snapshot => {
                localStorage.setItem("user_role", snapshot.data().role)
                localStorage.setItem("user_client", snapshot.data().client)
                localStorage.setItem("uid", snapshot.id)
                vm.user_home_client = snapshot.data().client
                vm.user_role = snapshot.data().role
                vm.user = snapshot.data()
            })
            this.authListener.push(l)
        },
        startUserListener() {
            let vm = this;
            firebase.auth().onAuthStateChanged((user) => {
                if (user) {
                    let l = firebase.firestore().collection('users').doc(user.uid).onSnapshot(snapshot => {
                        localStorage.setItem("user_role", snapshot.data().role)
                        localStorage.setItem("user_client", snapshot.data().client)
                        localStorage.setItem("uid", snapshot.id)
                    })
                    vm.authListener.push(l)
                } else {
                    localStorage.setItem("user_role", false)
                    localStorage.setItem("user_client", false)
                    localStorage.setItem("uid", false)
                }
            });
        },
        async login(email, password) {
            try {
                await firebase.auth().signInWithEmailAndPassword(email, password)
            } catch (e) {
                if (e.code == "auth/wrong-password") {
                    this.authLoading = false
                    this.wrong_password = true
                } else {
                    console.log("e: ", e.code)
                    this.authLoading = false
                    alert("Strange error")
                }
            }

        },
        logout() {
            this.clearVisitData()
            this.clearMarketData()
            this.clearchecklistData()
            this.clearAuthListener()
            var vm = this
            firebase.auth().signOut()
                .then(() => {
                    localStorage.clear()
                })
                .catch(error => {
                    vm.error = error
                })
        },
        register(email, password) {
            firebase.auth().createUserWithEmailAndPassword(
                email,
                password
            ).then(response => {
                firebase.firestore().collection('users').doc(response.user.uid).set({
                    email: response.user.email,
                    id: response.user.uid,
                    role: "",
                    client: ""
                });
            })
                .then(() => this.authLoading = false);
        },
        request_delete(email){
            firebase.firestore().collection('request_deleteion').add({
                email: email,
                time: Date.now()
            });
        }
    }
}